module.exports = __webpack_public_path__ + "img/spins_900.4534097b.png";